// extracted by mini-css-extract-plugin
export default {"title":"CampaignsTop5_title__yDO7G"};